import { useCallback } from 'react';

import { useJobContext } from 'pages/Job/context';
import { scrollToTop } from 'utils';

export interface AcceptQuoteHook {
  isLoading: boolean;
  onAcceptClick: () => void;
}

export default function useAcceptQuote(): AcceptQuoteHook {
  const { isLoading, job, goToPage } = useJobContext();

  const onAcceptClick = useCallback(() => {
    if (!job || isLoading) return;
    scrollToTop();
    goToPage('CHECKOUT');
  }, [job, isLoading, goToPage]);

  return {
    isLoading,
    onAcceptClick,
  };
}
